import { createSlice } from "@reduxjs/toolkit";

const defaultColumns = [
  "Name",
  "Role",
  "Job Title",
  "User Type",
  "Phone (Main)",
  "Phone (Mobile)",
  "Email Address",
  "Status",
];

const initialState = {
  selectedColumns: [
    "Name",
    "Role",
    "Job Title",
    "User Type",
    "Phone (Main)",
    "Phone (Mobile)",
    "Email Address",
    "Status",
  ],
};

export const usersColumnSlice = createSlice({
  name: "usersColumn",
  initialState,
  reducers: {
    setColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    setDefaultColumns: (state) => {
      state.selectedColumns = defaultColumns;
    },
  },
});

export const { setColumns, setDefaultColumns } = usersColumnSlice.actions;
export default usersColumnSlice.reducer;
